import request from "./request";
/**
 * 分页查询授权中心列表
 * @param pageName 专页名称
 * @param pageNumber 当前页数
 * @param pageSize 页数大小
 */
export default async function getDataAuthorizationPage(params = {}) {
  const defaultParams = {
    pageNumber: 1,
    pageSize: 10,
  };
  return await request.get("/spin/dataAuthorization/getDataAuthorizationPage", {
    params: { ...defaultParams, ...params },
  });
}
